import React from 'react';

import { Message, MessageProps } from '../Message';
import { ThreadStart as DefaultThreadStart } from './ThreadStart';

import { useComponentContext } from '../../context';

import type { DefaultBeloChatGenerics } from '../../types/types';

export const ThreadHead = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  props: MessageProps<BeloChatGenerics>,
) => {
  const { ThreadStart = DefaultThreadStart } = useComponentContext<BeloChatGenerics>('ThreadHead');
  return (
    <div className='str-chat__parent-message-li'>
      <Message initialMessage threadList {...props} />
      <ThreadStart />
    </div>
  );
};
